import { Easing } from "../types";

const easingLinear: Easing = (x) => x;

export default easingLinear;
